import PageLayout from "@/components/feature/PageLayout";
import { Link } from "react-router-dom";

export default function CancellingPage() {
  return (
    <PageLayout>
      <div className="bg-white rounded-2xl border border-gray-200 p-8">
        <div className="mb-1">
          <span className="text-xs font-bold uppercase tracking-widest text-gray-400">Subscription Management</span>
        </div>
        <h2 className="text-xl font-bold text-gray-900 mb-4">Cancelling my subscription</h2>
        <div className="space-y-4 text-sm">
          <p className="text-gray-500">
            You can cancel your subscription at any time by contacting our support team directly. We make the process as simple as possible — no complicated forms or lengthy procedures.
          </p>
          <h4 className="font-semibold text-gray-800">How to cancel:</h4>
          <ol className="list-decimal list-inside space-y-2 text-gray-500">
            <li>Send an email to <a href="mailto:support@kingcraftech.com" className="text-gray-700 underline font-medium hover:text-gray-900 transition-colors">support@kingcraftech.com</a></li>
            <li>Include your account email address and the reason for cancellation</li>
            <li>Our team will process your request within 1–2 business days</li>
            <li>You will receive a confirmation email once your subscription is cancelled</li>
          </ol>
          <p className="text-gray-500">
            Once cancelled, you will retain access to the service until the end of your current billing period. No further charges will be made after cancellation.
          </p>
          <div className="bg-gray-50 border border-gray-200 rounded-xl p-4">
            <p className="text-sm text-gray-500">
              <strong className="text-gray-700">Note:</strong> If you believe you were charged after cancellation, please submit a dispute form and we will investigate immediately.
            </p>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-gray-100 flex flex-col sm:flex-row gap-3">
          <Link to="/contact-support" className="inline-block bg-[#2d2f36] text-white px-5 py-2.5 rounded-xl text-sm font-semibold hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer text-center">
            Contact Support
          </Link>
          <Link to="/dispute-resolution" className="inline-block border border-gray-200 text-gray-700 px-5 py-2.5 rounded-xl text-sm font-medium hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer text-center">
            Submit a Dispute Form
          </Link>
        </div>
      </div>
    </PageLayout>
  );
}
